import React, { useState, useEffect } from "react";
import {
  Header,
  Container,
  Label,
  Form,
  Button,
  Grid,
  Icon,
} from "semantic-ui-react";
import {
  FASE_APERTURA_CUENTA_DPF_INICIAL,
  FASE_APERTURA_CUENTA_DPF_CONFIRMACION,
  FASE_APERTURA_CUENTA_AHORROS_COMPLETADO,
  LABEL_HE_LEIDO_DOCUMENTOS_CONTRACTUALES_APERTURA_CUENTA,
  MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES,
  NOMBRE_TIPO_CUENTA_DPF,
  LONGITUD_MAXIMA_IMPORTE,
  LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR,
  LABEL_INGRESE_CLAVE_DOBLE_FACTOR,
  MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR,
  RESPONSE_MESSAGE_CODE_SUCCESS,
  LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
  VALOR_MINIMO_PLAZO,
  VALOR_MAXIMO_PLAZO,
  LONGITUD_MAXIMA_PLAZO,
  CODIGO_TIPO_CUENTA_PASIVO_DPF,
  CODIGO_TIPO_PROCESO_AUDITORIA_APERTURA_CUENTA_DPF,
} from "../../../../app/infrastructure/appConstants";
import AperturarCuentaDPFHeader from "./AperturarCuentaDPFHeader";
import { tipoMonedaOptions } from "../../../../app/config/data/options";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  aperturarCuentaDPFValidar,
  aperturarCuentaDPFConfirmar,
  getCuentasOperaciones,
  getProductosCuentaApertura,
} from "../../../../app/store/actions/cuentaActions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { Form as FinalForm, Field } from "react-final-form";
import CheckboxInput from "../../../../app/common/form/CheckboxInput";
import {
  combineValidators,
  composeValidators,
  isRequired,
  isOneOf,
  hasLengthBetween,
} from "revalidate";
import { Link } from "react-router-dom";
import AperturarCuentaDPFResumen from "./AperturarCuentaDPFResumen";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import { createOptionsCuentaAperturarCargo } from "../../../../app/util/optionsUtils";
import NumberInput from "../../../../app/common/form/NumberInput";
import {
  isBetween,
  isGreaterThanOrEqual,
} from "../../../../app/util/revalidateUtils";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import { toast } from "react-toastify";
import {
  generarClaveDobleFactor,
  validarClaveDobleFactor,
} from "../../../../app/store/actions/transactionalActions";
import ModalClaveDobleFactor from "../../../../app/common/modals/ModalClaveDobleFactor";
import { normalizeNumero } from "../../../../app/util/finalFormUtils";
import TextInput from "../../../../app/common/form/TextInput";
import {
  MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
  TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL,
} from "../../../../app/util/messageUtils";
import DisponibilidadOperaciones from "../../../../app/common/messages/DisponibilidadOperacionesMessage";
import ListaDocumentosContractuales from "../common/ListaDocumentosContractuales";
import { resetScroll } from "../../../../app/util/JsUtils";
import {
  getUrlDocumentoCartillaDpf,
  getUrlDocumentoContratoDpf,
} from "../../../../app/util/cuentaUtils";
import {
  buildGenerarClaveDobleFactorRequest,
  buildValidarClaveDobleFactorRequest,
} from "../../../../app/util/transactionalUtils";

const actions = {
  aperturarCuentaDPFValidar,
  aperturarCuentaDPFConfirmar,
  getCuentasOperaciones,
  verificarDisponibilidadPago,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  getProductosCuentaApertura,
};

const mapState = (state) => ({
  loadingAperturarCuentaDPFValidar:
    state.cuentaReducer.loadingAperturarCuentaDPFValidar,
  loadingAperturarCuentaDPFConfirmar:
    state.cuentaReducer.loadingAperturarCuentaDPFConfirmar,
  cuentasOperaciones: state.cuentaReducer.cuentasOperaciones,
  loadingCuentasOperaciones: state.cuentaReducer.loadingCuentasOperaciones,
  currentUser: state.auth.currentUser,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  loadingGenerarClaveDobleFactor:
    state.transactionalReducer.loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor:
    state.transactionalReducer.loadingValidarClaveDobleFactor,
  claveDobleFactorUsuario: state.transactionalReducer.claveDobleFactorUsuario,
  productosCuenta: state.cuentaReducer.productosCuenta,
  loadingProductosCuentaApertura:
    state.cuentaReducer.loadingProductosCuentaApertura,
});

const AperturarCuentaDPFPage = ({
  aperturarCuentaDPFValidar,
  loadingAperturarCuentaDPFValidar,
  aperturarCuentaDPFConfirmar,
  loadingAperturarCuentaDPFConfirmar,
  cuentasOperaciones,
  loadingCuentasOperaciones,
  getCuentasOperaciones,
  currentUser,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor,
  claveDobleFactorUsuario,
  getProductosCuentaApertura,
  productosCuenta,
  loadingProductosCuentaApertura,
}) => {
  //Constantes
  const generarClaveDobleFactorRequest = buildGenerarClaveDobleFactorRequest(
    CODIGO_TIPO_PROCESO_AUDITORIA_APERTURA_CUENTA_DPF,
    claveDobleFactorUsuario
  );
  //hook effect
  useEffect(() => {
    if(currentUser){
      getCuentasOperaciones();
    }
  }, [getCuentasOperaciones, currentUser?.username]);

  useEffect(() => {
    if(currentUser){
      getProductosCuentaApertura({
        tipoCuenta: CODIGO_TIPO_CUENTA_PASIVO_DPF,
        codigoMoneda: "%",
        tipoPersona: currentUser.tipoPersona,
      });
    }
  }, [getProductosCuentaApertura, currentUser.tipoPersona]);

  //states
  const [faseAperturaCuenta, setFaseAperturaCuenta] = useState(
    FASE_APERTURA_CUENTA_DPF_INICIAL
  );
  const [codigoMoneda, setCodigoMoneda] = useState(null);
  const [tasaInteres, setTasaInteres] = useState(null);
  const [interesRecibir, setInteresRecibir] = useState(null);
  const [plazo, setPlazo] = useState(null);
  const [cuentaCargo, setCuentaCargo] = useState(null);
  const [importeApertura, setImporteApertura] = useState(null);
  const [numeroCuentaCreada, setNumeroCuentaCreada] = useState(null);
  const [claveDobleFactor, setClaveDobleFactor] = useState(null);
  const [
    indicadorAceptacionTerminos,
    setIndicadorAceptacionTerminos,
  ] = useState(false);
  const [
    flagGeneracionExitosaClaveDobleFactor,
    setGeneracionExitosaClaveDobleFactor,
  ] = useState(false);
  const [
    msgValidacionClaveDobleFactor,
    setMsgValidacionClaveDobleFactor,
  ] = useState(null);
  const [
    openModalGenerarClaveDobleFactor,
    setOpenModalGenerarClaveDobleFactor,
  ] = useState(false);
  const [aplicaTipoCambio, setAplicaTipoCambio] = useState(false);
  const [tipoCambioValidado, setTipoCambioValidado] = useState(null);
  const [codigoMonedaCuentaOrigen, setCodigoMonedaCuentaOrigen] = useState(
    null
  );
  const [periodoPagoValidado, setPeriodoPagoValidado] = useState(null);
  const [formaPagoValidado, setFormaPagoValidado] = useState(null);
  const [importeDebitarValidado, setImporteDebitarValidado] = useState(null);
  const [monedaDebitarValidado, setMonedaDebitarValidado] = useState(null);

  //Business
  const validarAperturaCuenta = async () => {
    //Validar saldo de cuenta

    const response = await verificarDisponibilidadPago();
    if (response && response.data && response.data.disponible === true) {
      const validarAperturaResponse = await aperturarCuentaDPFValidar({
        codigoMoneda,
        saldo: importeApertura,
        periodo: plazo,
        cuentaCargo: cuentaCargo,
      });
      if (validarAperturaResponse && validarAperturaResponse.tasa) {
        try {
          //Generando clave doble factor
          const response = await generarClaveDobleFactor(
            generarClaveDobleFactorRequest
          );
          //end
          if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
            setGeneracionExitosaClaveDobleFactor(true);
            setTasaInteres(validarAperturaResponse.tasa);
            setInteresRecibir(validarAperturaResponse.interesGanado);
            setTipoCambioValidado(validarAperturaResponse.tipoCambio);
            setAplicaTipoCambio(codigoMonedaCuentaOrigen !== codigoMoneda);
            setPeriodoPagoValidado(validarAperturaResponse.periodoPago);
            setFormaPagoValidado(validarAperturaResponse.formaPago);
            setMonedaDebitarValidado(validarAperturaResponse.monedaRetiro);
            setImporteDebitarValidado(validarAperturaResponse.importeRetiro);
            //Fase confirmacion
            setFaseAperturaCuenta(FASE_APERTURA_CUENTA_DPF_CONFIRMACION);
            resetScroll();
          }
        } catch (error) {
          if (error && error.data && error.data.status !== 401) {
            toast.error(error.data.message);
          }
        }
      }
    }
  };

  const atrasAperturaCuenta = (event) => {
    event.preventDefault();
    setFaseAperturaCuenta(FASE_APERTURA_CUENTA_DPF_INICIAL);
    setTasaInteres(null);
    setClaveDobleFactor(null);
    setPeriodoPagoValidado(null);
    setFormaPagoValidado(null);
    setMonedaDebitarValidado(null);
    setImporteDebitarValidado(null);
  };

  const handleConfirmarAperturaCuenta = async (values) => {
    //Validando Clave doble factor
    let responseValidacionClaveDobleFactor;
    try {
      responseValidacionClaveDobleFactor = await validarClaveDobleFactor(
        buildValidarClaveDobleFactorRequest(
          claveDobleFactorUsuario,
          claveDobleFactor
        )
      );
    } catch (error) {
      const msgValidacion = error.data.message;
      setMsgValidacionClaveDobleFactor(msgValidacion);
      setGeneracionExitosaClaveDobleFactor(false);
      setOpenModalGenerarClaveDobleFactor(true);
      setClaveDobleFactor(null);
    }
    //end
    if (
      responseValidacionClaveDobleFactor &&
      responseValidacionClaveDobleFactor.code === RESPONSE_MESSAGE_CODE_SUCCESS
    ) {
      const confirmarAperturaResponse = await aperturarCuentaDPFConfirmar({
        codigoMoneda,
        saldo: importeApertura,
        periodo: plazo,
        cuentaCargo: cuentaCargo,
        aceptoClausulas: indicadorAceptacionTerminos,
      });
      if (confirmarAperturaResponse && confirmarAperturaResponse.numeroCuenta) {
        setFaseAperturaCuenta(FASE_APERTURA_CUENTA_AHORROS_COMPLETADO);
        setNumeroCuentaCreada(confirmarAperturaResponse.numeroCuenta);
        resetScroll();
      }
    }
  };

  //validate
  const validateConfirmarApertura = combineValidators({
    indicadorAceptacionTerminos: composeValidators(
      isRequired({
        message: MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES,
      }),
      isOneOf([true])
    )({ message: MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES }),
    claveDobleFactor: composeValidators(
      isRequired({ message: MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR }),
      hasLengthBetween(
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR
      )({
        message: MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
      })
    )(),
  });

  const validateValidarApertura = combineValidators({
    tipoMoneda: composeValidators(
      isRequired({ message: "Debe seleccionar una moneda" })
    )(),
    plazo: composeValidators(
      isRequired({ message: "Debe ingresar el plazo" }),
      isBetween(
        VALOR_MINIMO_PLAZO,
        VALOR_MAXIMO_PLAZO
      )({
        message: `El plazo mínimo es de 30 días`,
      })
    )(),
    importeApertura: composeValidators(
      isRequired({ message: "Importe es requerido" }),
      isGreaterThanOrEqual(1)({
        message: `El importe tiene que ser mayor a 0`,
      })
    )(),
    cuentaCargo: composeValidators(
      isRequired({ message: "Debe seleccionar una cuenta cargo" })
    )(),
  });

  //Options
  const cuentasOptions = createOptionsCuentaAperturarCargo(cuentasOperaciones);

  if (loadingCuentasOperaciones)
    return <LoadingComponent content="Cargando cuentas operaciones..." />;
  if (loadingAperturarCuentaDPFValidar)
    return <LoadingComponent content="Validando apertura de cuenta..." />;
  if (loadingAperturarCuentaDPFConfirmar)
    return <LoadingComponent content="Creando cuenta..." />;
  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;
  if (loadingGenerarClaveDobleFactor)
    return <LoadingComponent content="Generar Clave..." />;
  if (loadingValidarClaveDobleFactor)
    return <LoadingComponent content="Validar Clave..." />;
  if (loadingProductosCuentaApertura)
    return <LoadingComponent content="Listar Producto Cuentas..." />;
  return (
    <>
      <Container className="containerPrincipal">
        {faseAperturaCuenta === FASE_APERTURA_CUENTA_DPF_INICIAL ? (
          <>
            <AperturarCuentaDPFHeader />
            <div style={{ marginTop: "2.5em" }}>
              <Header as="h4" color="blue" content="Tipo de cuenta" />

              <Label color="blue" tag size="large">
                {NOMBRE_TIPO_CUENTA_DPF}
              </Label>

              <FinalForm
                onSubmit={(values) => {
                  validarAperturaCuenta(values);
                }}
                initialValues={{
                  tipoMoneda: codigoMoneda,
                  plazo: plazo,
                  cuentaCargo: cuentaCargo,
                  importeApertura: importeApertura,
                }}
                validate={validateValidarApertura}
                render={({
                  handleSubmit,
                  submitting,
                  submitError,
                  invalid,
                  pristine,
                  dirtySinceLastSubmit,
                  values,
                }) => (
                  <Form
                    onSubmit={handleSubmit}
                    error
                    style={{ marginTop: "2.5em" }}
                  >
                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona la moneda"
                    />
                    <Field
                      name="tipoMoneda"
                      component={SelectedInput}
                      placeholder="Selecciona la moneda"
                      options={tipoMonedaOptions}
                      handleOnChange={(value) => {
                        setCodigoMoneda(value);
                      }}
                    />

                    <Header as="h4" color="blue" content="Ingresa el importe" />
                    <Field
                      name="importeApertura"
                      component={NumberInput}
                      placeholder="Ingresa el importe"
                      handleOnChange={(value) => {
                        setImporteApertura(value);
                      }}
                      disabled={!codigoMoneda}
                      maxLength={LONGITUD_MAXIMA_IMPORTE}
                    />

                    <Header as="h4" color="blue" content="Ingresa el plazo" />
                    <Field
                      name="plazo"
                      component={NumberInput}
                      decimalScale={"0"}
                      placeholder="Ingresa el plazo"
                      handleOnChange={(value) => {
                        setPlazo(Number(value));
                      }}
                      maxLength={LONGITUD_MAXIMA_PLAZO}
                    />

                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona la cuenta cargo"
                    />
                    <Field
                      name="cuentaCargo"
                      component={SelectedInput}
                      placeholder="Selecciona la cuenta cargo"
                      options={cuentasOptions}
                      handleOnChange={(value) => {
                        setCuentaCargo(value);
                        if (
                          value &&
                          cuentasOperaciones &&
                          cuentasOperaciones.length > 0
                        ) {
                          const cuenta = cuentasOperaciones.filter(
                            (c) => c.numeroCuenta === value
                          )[0];
                          setCodigoMonedaCuentaOrigen(cuenta.codigoMoneda);
                        }
                      }}
                    />
                    {codigoMonedaCuentaOrigen &&
                      codigoMoneda &&
                      codigoMonedaCuentaOrigen !== codigoMoneda && (
                        <Label color="blue" tag size="medium">
                          {TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL}
                        </Label>
                      )}
                    {/* <pre>{JSON.stringify(values)}</pre> */}
                    <br />
                    <br />
                    <Container textAlign="center">
                      <Button
                        disabled={invalid}
                        size="large"
                        color="yellow"
                        content="Siguiente"
                        style={{ minWidth: "12em", maxWidth: "15em" }}
                        loading={submitting}
                      />
                    </Container>
                  </Form>
                )}
              />
            </div>
          </>
        ) : faseAperturaCuenta === FASE_APERTURA_CUENTA_DPF_CONFIRMACION ? (
          <>
            {tasaInteres && (
              <>
                <AperturarCuentaDPFHeader />
                <DisponibilidadOperaciones />
                <div style={{ marginTop: "2.5em" }}>
                  <Header
                    as="h4"
                    color="blue"
                    content="Confirmación de apertura de cuenta"
                  />
                  <AperturarCuentaDPFResumen
                    codigoMoneda={codigoMoneda}
                    tasaInteres={tasaInteres}
                    plazo={plazo}
                    importe={importeApertura}
                    cuentaCargo={cuentaCargo}
                    interesRecibir={interesRecibir}
                    aplicaTipoCambio={aplicaTipoCambio}
                    tipoCambio={tipoCambioValidado}
                    periodoPago={periodoPagoValidado}
                    formaPago={formaPagoValidado}
                    importeDebitarValidado={importeDebitarValidado}
                    monedaDebitarValidado={monedaDebitarValidado}
                  />
                  <br />
                  <FinalForm
                    onSubmit={(values) => {
                      handleConfirmarAperturaCuenta(values);
                    }}
                    validate={validateConfirmarApertura}
                    initialValues={{
                      indicadorAceptacionTerminos: indicadorAceptacionTerminos,
                      claveDobleFactor: claveDobleFactor,
                    }}
                    render={({
                      handleSubmit,
                      submitting,
                      submitError,
                      invalid,
                      pristine,
                      dirtySinceLastSubmit,
                      values,
                    }) => (
                      <Form onSubmit={handleSubmit} error>
                        <ListaDocumentosContractuales
                          urlDocumentoContrato={getUrlDocumentoContratoDpf(
                            productosCuenta,
                            codigoMoneda,
                            currentUser.tipoPersona
                          )}
                          urlDocumentoPlantilla={getUrlDocumentoCartillaDpf(
                            productosCuenta,
                            codigoMoneda,
                            currentUser.tipoPersona
                          )}
                        />
                        <br />
                        <Field
                          name="indicadorAceptacionTerminos"
                          component={CheckboxInput}
                          type="checkbox"
                          label={
                            LABEL_HE_LEIDO_DOCUMENTOS_CONTRACTUALES_APERTURA_CUENTA
                          }
                          handleOnChange={(value) => {
                            setIndicadorAceptacionTerminos(value);
                          }}
                          checked={indicadorAceptacionTerminos}
                        />
                        <Header
                          as="h4"
                          color="blue"
                          content={LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR}
                          textAlign="left"
                        />
                        <Field
                          name="claveDobleFactor"
                          component={TextInput}
                          placeholder={LABEL_INGRESE_CLAVE_DOBLE_FACTOR}
                          maxLength={LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR}
                          parse={normalizeNumero}
                          handleOnChange={(value) => {
                            setClaveDobleFactor(normalizeNumero(value));
                          }}
                        />
                        <br />
                        <Grid>
                          <Grid.Row>
                            <Grid.Column
                              computer={4}
                              largeScreen={4}
                              mobile={7}
                              tablet={6}
                            >
                              <Button
                                fluid
                                content="Atrás"
                                color="blue"
                                size="large"
                                onClick={(event) => atrasAperturaCuenta(event)}
                              />
                            </Grid.Column>
                            <Grid.Column
                              computer={8}
                              largeScreen={8}
                              mobile={2}
                              tablet={4}
                            />
                            <Grid.Column
                              computer={4}
                              largeScreen={4}
                              mobile={7}
                              tablet={6}
                            >
                              <Button
                                content="Confirmar"
                                disabled={
                                  invalid &&
                                  flagGeneracionExitosaClaveDobleFactor
                                }
                                loading={submitting}
                                fluid
                                color="yellow"
                                size="large"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Form>
                    )}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <Container style={{ width: "65%" }} textAlign="center">
              <br />
              <Icon name="check circle outline" color="yellow" size="huge" />
              <Header as="h1" color="blue" size="huge">
                Se creó tu cuenta con éxito
              </Header>
              <Header as="h4" color="blue" size="tiny">
                Te enviamos un correo con el detalle de la apertura de tu
                cuenta.
              </Header>
              <AperturarCuentaDPFResumen
                codigoMoneda={codigoMoneda}
                tasaInteres={tasaInteres}
                plazo={plazo}
                numeroCuenta={numeroCuentaCreada}
                importe={importeApertura}
                cuentaCargo={cuentaCargo}
                interesRecibir={interesRecibir}
                aplicaTipoCambio={aplicaTipoCambio}
                tipoCambio={tipoCambioValidado}
                periodoPago={periodoPagoValidado}
                formaPago={formaPagoValidado}
                importeDebitarValidado={importeDebitarValidado}
                monedaDebitarValidado={monedaDebitarValidado}
              />
              <br />
              <Container textAlign="center">
                <Button
                  to="/cuentas"
                  as={Link}
                  color="yellow"
                  size="large"
                  content="Ir a mis cuentas"
                />
              </Container>
            </Container>
          </>
        )}
      </Container>
      <ModalClaveDobleFactor
        openModel={openModalGenerarClaveDobleFactor}
        generarClaveDobleFactorRequest={generarClaveDobleFactorRequest}
        msgValidacionClaveDobleFactor={msgValidacionClaveDobleFactor}
        setGeneracionExitosaClaveDobleFactor={
          setGeneracionExitosaClaveDobleFactor
        }
        setOpenModalGenerarClaveDobleFactor={
          setOpenModalGenerarClaveDobleFactor
        }
      />
    </>
  );
};

AperturarCuentaDPFPage.propTypes = {
  loadingAperturarCuentaDPFValidar: PropTypes.bool.isRequired,
  aperturarCuentaDPFValidar: PropTypes.func.isRequired,
  loadingAperturarCuentaDPFConfirmar: PropTypes.bool.isRequired,
  cuentasOperaciones: PropTypes.array.isRequired,
  getCuentasOperaciones: PropTypes.func.isRequired,
  loadingCuentasOperaciones: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
  generarClaveDobleFactor: PropTypes.func.isRequired,
  validarClaveDobleFactor: PropTypes.func.isRequired,
  claveDobleFactorUsuario: PropTypes.object,
  getProductosCuentaApertura: PropTypes.func.isRequired,
  productosCuenta: PropTypes.array.isRequired,
  loadingProductosCuentaApertura: PropTypes.bool.isRequired,
};

export default connect(mapState, actions)(AperturarCuentaDPFPage);
